const LOCAL_HOSTS = ['localhost', '127.0.0.1'];

function defaultApiRoot() {
  if (typeof window === 'undefined') {
    return '/php';
  }

  if (LOCAL_HOSTS.includes(window.location.hostname)) {
    return 'https://www.malwaregame.com/php';
  }

  return `${window.location.origin}/php`;
}

export const API_ROOT = (process.env.REACT_APP_API_ROOT || defaultApiRoot()).replace(/\/$/, '');

export function apiUrl(path) {
  return `${API_ROOT}/${String(path).replace(/^\//, '')}`;
}

export function apiFetch(path, options = {}) {
  return fetch(apiUrl(path), {
    credentials: 'include',
    ...options,
  });
}
